

import { Vue, Component, Prop } from "vue-property-decorator";
import { INotificationItem } from "@/store/modules/notification/interface";
import Toast from "./Toast.vue";

@Component({
	components: {
		Toast
	}
})
export default class ToastList extends Vue {

	@Prop({ type: Boolean, default: false })
	fixed!: boolean;

	@Prop({ type: Array, default: () => [] })
	list!: INotificationItem[];

	@Prop(Boolean)
	readonly bottom?: boolean

	get filteredList(): INotificationItem[] {
		try {
			return this.list.filter(i => !i.showModal);
		} catch (err) {
			console.warn("ToastList -> getter -> filteredList", err);
		}

		return [];
	}

}

